import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/common/app';
import extractText from 'flarum/common/utils/extractText';
import Embed from '../models/Embed';
import imageUrl from '../utils/imageUrl';

export interface IconAttrs {
    embed: Embed
    inline?: boolean
}

export default class Icon implements ClassComponent<IconAttrs> {
    view(vnode: Vnode<IconAttrs, this>) {
        const src = this.src(vnode);

        return src ? m('img.rich-embed-favicon', {
            src: imageUrl(src),
            alt: this.alt(vnode),
        }) : null;
    }

    src(vnode: Vnode<IconAttrs, this>): string | null {
        const preview = vnode.attrs.embed.preview() || {};

        if (preview.icon) {
            return preview.icon;
        }

        const icons = vnode.attrs.embed.icons();

        if (icons?.length) {
            return icons[0].href;
        }

        return null;
    }

    alt(vnode: Vnode<IconAttrs, this>): string {
        const preview = vnode.attrs.embed.preview() || {};

        return extractText(app.translator.trans('kilowhat-rich-embeds.lib.embed.altFavicon', {
            website: preview.siteName,
        }));
    }
}
